import React from 'react';

const IconSearch  = () => {
  return (
    <svg className="icon-search" xmlns="http://www.w3.org/2000/svg" width="289.706" height="289.706" viewBox="0 0 289.706 289.706"><path d="M112.1,212.548A100.451,100.451,0,1,0,11.646,112.1,100.451,100.451,0,0,0,112.1,212.548Zm83.276-25.41L288,279.765A5.823,5.823,0,0,1,279.765,288l-92.627-92.627a112.1,112.1,0,1,1,8.235-8.235Z"/></svg>
  )
}

export default IconSearch;